export default __webpack_public_path__ + "static/media/Celular completo.632262ac.png";